import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import React from 'react';
import moment from 'moment';
import { FactorNotificationComponent } from 'components/FactorNotificationComponent/FactorNotificationComponent';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { useSeenModulePixel } from 'hook/helper.hook';
import {
  factorMapping,
  providerMapping,
} from 'customHelpersPath/factorMapping.helper';
import './PaymentHistoryNotificationsModuleView.scss';
import { CreditBureauProviderCamelCase } from 'pages/QuarterlyReport/constants';
import * as Constants from 'types/mrph.pageName.constants';
import { BUREAU_ATTRIBUTE_NAME_MAP } from 'pages/RedesignDashboard/constants';
import OText from 'components/CText/OText';

const PaymentHistoryNotificationsModuleView = props => {
  const {
    notifications,
    history,
    selectedFactor,
    selectedBureau,
    selectedFactorGrade,
    eventHandler,
    config,
  } = props;

  const reportPulledDate = props?.creditInfo?.reportPulledDate;
  const lastRefreshDate = props?.creditInfo?.lastRefreshDate;

  const displayDate =
    selectedBureau === 'TRANS_UNION' ? lastRefreshDate : reportPulledDate;

  let color = '';
  switch (selectedFactorGrade) {
    case 'A':
      color = 'green3';
      break;
    case 'B':
      color = 'lgreen3';
      break;
    case 'C':
      color = 'yellow2';
      break;
    case 'D':
      color = 'orange2 ';
      break;
    case 'F':
      color = 'red3';
      break;
    default:
      color = 'gray bgGray025';
      break;
  }

  const trackingAtr = getViewModuleTrackingAttributes({
    pagePosition:
      'Grade Dial ' +
      CreditBureauProviderCamelCase[selectedBureau] +
      ' ' +
      Constants[selectedFactor],
    modulePosition: 1,
  });
  const seenModuleTracking = useSeenModulePixel(trackingAtr);

  return (
    <FlexContainer
      className={
        'flex-column paymentHistoryNotificationsContainer marglr48 m-marglr16'
      }
    >
      {seenModuleTracking}
      <FlexContainer className={'justify-beetween margt40 m-margt20 gap-24'}>
        <Label
          type="H5"
          typeHeader={'h5'}
          className={`${color} optionIconContainer bold  text-23 text-center padT6`}
        >
          {selectedFactorGrade ?? 'C'}
        </Label>
        <FlexContainer className={'flex-column'}>
          <Label
            type="H4 m-H5"
            typeHeader={'h4'}
            className="format70 bold flex-column width100 margB0"
          >
            {factorMapping?.get(selectedFactor)}
          </Label>
          <Label className="text-12 bold">
            {config.creditFactorsSubtitles?.[selectedFactor]?.onlyText
              ? 'About this score factor:'
              : `Updated ${moment(displayDate).format(
                  'll',
                )} based on your latest report from ${providerMapping.get(
                  selectedBureau,
                )}.`}
          </Label>
          <Label className="text-10 margT6">
            {config.creditFactorsSubtitles?.[selectedFactor]?.onlyText
              ? ''
              : config.creditFactorsSubtitles?.[selectedFactor]?.provider
              ? `${config.creditFactorsSubtitles?.[selectedFactor]?.providerText}${config.creditFactorsSubtitles?.[selectedFactor]?.provider}`
              : `${
                  config.creditFactorsSubtitles?.[selectedFactor]?.providerText
                }${providerMapping.get(selectedBureau)}.`}
            <OText
              text={config.creditFactorsSubtitles?.[selectedFactor]?.text}
            />
          </Label>
        </FlexContainer>
      </FlexContainer>
      <FlexContainer className={'flex-column margt8'}>
        {notifications?.map(
          notification =>
            !notification?.viewed && (
              <FactorNotificationComponent
                key={'notification' + notification?.id}
                notification={notification?.enhancedTitle}
                icon={'notificationsAlertsIcon'}
                history={history}
                urlToNotification={'/alerts/all/' + notification?.id}
                eventHandler={eventHandler}
              />
            ),
        )}
      </FlexContainer>
    </FlexContainer>
  );
};

export default PaymentHistoryNotificationsModuleView;
